import type { RefObject } from 'react';

import type { PopupProps } from '@atlaskit/popup/types';

import { isFocusMovingRole } from './is-focus-moving-role';

export function shouldMoveFocus({
	container,
	role,
	shouldTransferFocusRef,
	triggerRef,
}: {
	container: HTMLElement;
	role?: PopupProps['role'];
	shouldTransferFocusRef: RefObject<boolean>;
	triggerRef: RefObject<HTMLElement | null>;
}): boolean {
	if (!isFocusMovingRole({ role })) {
		return false;
	}
	const activeElement = container.ownerDocument.activeElement;
	return (
		shouldTransferFocusRef.current ||
		container.contains(activeElement) ||
		activeElement === triggerRef.current
	);
}
